"use client";

import { ChevronDown, Languages } from "lucide-react";
import { useEffect, useState } from "react";
import { LOCALE_COOKIE, SUPPORTED_LOCALES, getLocaleLabel, type Locale } from "@/lib/locale";
import { useI18n } from "./I18nProvider";

export function LocaleSwitcher({ className = "locale-switcher" }: { className?: string }) {
  const { locale, t } = useI18n();
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => setHydrated(true), []);

  function switchLocale(targetLocale: Locale) {
    if (targetLocale === locale) return;
    document.cookie = `${LOCALE_COOKIE}=${encodeURIComponent(targetLocale)}; Path=/; Max-Age=31536000; SameSite=Lax`;
    window.location.reload();
  }

  return (
    <label
      className={`${className} locale-select`}
      title={t("global.languageSwitch")}
    >
      <Languages className="locale-select-icon" size={15} aria-hidden="true" />
      <span className="locale-select-current" aria-hidden="true">
        <span>{getLocaleLabel(locale)}</span>
        <ChevronDown size={13} />
      </span>
      <select
        className="locale-select-control"
        defaultValue={locale}
        key={locale}
        disabled={!hydrated}
        aria-label={t("global.languageCurrent", { locale: getLocaleLabel(locale) })}
        onChange={(event) => switchLocale(event.target.value as Locale)}
      >
        {SUPPORTED_LOCALES.map((option) => (
          <option key={option} value={option}>{getLocaleLabel(option)}</option>
        ))}
      </select>
    </label>
  );
}
